import {cdnUrl} from '@/util/cdnImage';

/**
 * Default reviewer shown on every blog post when the WordPress editor has NOT
 * selected one in the "Reviewer Information" dropdown (`reviewer_info` is null).
 *
 * The WP selection always wins — this is only the fallback. See the resolver
 * `resolveReviewer()` below.
 */
export const DEFAULT_REVIEWER = {
    id: 17,
    name: 'Harry Dhillon',
    slug: 'harry-dhillon',
    designation: 'Director – Digital Transformation & Customer Success',
    bio: 'Harry Dhillon is the Director of Digital Transformation & Customer Success at Debut Infotech.',
    image: cdnUrl('blog/director-harry-dhillion.webp'),
    linkedin: 'https://www.linkedin.com/in/dhillonharry'
};

// Keyed by the stable WordPress reviewer id, NOT the display name — the name spelling
// ("Dhillon" vs "Dhillion") varies in WP, but the id (17 = Harry) never does, so this
// can't break from a backend typo.
const REVIEWER_LINKEDIN_BY_ID: Record<number, string> = {
    17: 'https://www.linkedin.com/in/dhillonharry' // Harry Dhillon
};

export const resolveReviewer = (reviewerInfo: any) => {
    if (!reviewerInfo?.name) return DEFAULT_REVIEWER;
    const knownLinkedin = REVIEWER_LINKEDIN_BY_ID[reviewerInfo.id];
    if (!reviewerInfo.linkedin?.trim() && knownLinkedin) {
        return {...reviewerInfo, linkedin: knownLinkedin};
    }
    return reviewerInfo;
};
